<template>
    <b-modal ref="profile_modal" size="xl" bodyClass="p-0" v-bind:no-close-on-backdrop="true" :hide-header="true" v-model="is_show_modal" :dialogClass="dialog_class_draw">
        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2>
                    <span class="fw-300">
                        {{ __t('AUTH_MANAGER_' + this.manager_type.toUpperCase()) }}
                    </span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" @click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-container show">
                        <div class="p-1">
                            <button class="btn btn-md btn-block btn-outline-success waves-effect waves-themed mt-3" @click="addItem">
                                <span class="fal fa-plus mr-1"></span>
                                {{ __t('ADD') }}
                            </button>

                            <div class="panel-content mb-0">
                                <b-table v-if="attached_items.length > 0"
                                         striped
                                         class="table-responsive-xl resolution_table"
                                         :items="attached_items"
                                         :fields="draw_fields"
                                         small
                                >
                                    <template #cell(id)="{ item }">
                                        <div class="text-muted">
                                            <div class="position-relative" v-if="manager_type == 'glovo'">
                                                <auth_state :key="item.id" :cur_location="item"></auth_state>
                                            </div>
                                            {{ item.id || '—' }}
                                        </div>
                                    </template>


                                    <template #cell(username)="{ item }">
                                        <b-form-input v-model="item.username" :disabled="item._otpMode" :placeholder="__t('GLOVO_USERNAME')" autocomplete="off" trim />
                                    </template>

                                    <template #cell(oauth)="{ item }">
                                        <button class="btn btn-sm btn-info" @click="attachOauth(item)">
                                            {{__t('AUTH.ATTACH_ACCOUNT')}}
                                            <i class="fal fa-prfofile-alt mr-1"></i>
                                        </button>
                                    </template>

                                    <template #cell(password)="{ item }">
                                        <div v-if="item._otpMode">
                                            <b-form-input v-model="item._otpCode" :placeholder="__t('ENTER_OTP_CODE') || 'Enter OTP code'" autocomplete="one-time-code" trim />
                                        </div>
                                        <div v-else>
                                            <b-form-input v-model="item.password" :placeholder="__t('GLOVO_PASSWORD')" autocomplete="new-password" trim />
                                        </div>
                                    </template>

                                    <!-- ACTIONS -->
                                    <template #cell(actions)="{ item }">
                                        <div class="d-flex justify-content-end">
                                            <!-- OTP mode buttons -->
                                            <template v-if="item._otpMode">
                                                <button class="btn btn-sm btn-success mr-2" :disabled="rowSaving === item || !item._otpCode" @click="sendOtp(item)">
                                                    <span v-if="rowSaving === item" class="spinner-border spinner-border-sm mr-1"></span>
                                                    <i v-else class="fal fa-paper-plane mr-1"></i>
                                                </button>
                                                <button class="btn btn-sm btn-secondary" @click="cancelOtp(item)">
                                                    <i class="fal fa-times mr-1"></i>
                                                </button>
                                            </template>

                                            <template v-else>

                                                <button class="btn btn-sm btn-success mr-2"
                                                        :disabled="rowSaving === item"
                                                        @click="saveItem(item)">
                                                    <span v-if="rowSaving === item" class="spinner-border spinner-border-sm mr-1"></span>
                                                    <i v-else class="fal fa-save mr-1"></i>
                                                </button>

                                                <button class="btn btn-sm btn-danger"
                                                        :disabled="rowDeleting === item"
                                                        @click="deleteItem(item)">
                                                    <span v-if="rowDeleting === item" class="spinner-border spinner-border-sm mr-1"></span>
                                                    <i v-else class="fal fa-trash-alt mr-1"></i>
                                                </button>
                                            </template>
                                        </div>
                                    </template>

                                    <template #cell(is_default)="{ item }">
                                        <button class="btn btn-sm" :class="item.is_default ? 'btn-warning' : 'btn-outline-secondary'" @click="setDefault(item)">
                                            <i class="fal fa-star"></i>
                                        </button>
                                    </template>

                                </b-table>
                            </div>
                        </div>
                    </div>
                </b-overlay>
            </div>
        </div>

        <template v-slot:modal-footer="{ close }">
            <div class="modal-footer"></div>
        </template>
    </b-modal>
</template>

<script>
import Auth_state from "./helpers/auth_state.vue";

export default {
    name: "external_manager",
    components: {Auth_state},

    data() {
        return {
            manager_type : "",
            manager_id : 0,
            manager_settings : {
                'fields' : []
            },

            is_show_modal: false,
            is_load: false,
            attached_items: [],
            rowSaving: null,
            rowDeleting: null,
            fields: [
                { key: 'id',        label: 'ID',                      class: 'text-center', thStyle: { width: '80px' } },
            ],
        }
    },

    created() {
        EventBus.$on("auth_manager", this.show_modal);
    },

    methods: {
        close() {
            this.is_show_modal = false;
        },

        attachOauth(item) {
            api.post('/internal/oauth/'+ this.manager_type +'/redirect').then(({data}) => {
                if (data.status === 'operation_success') {
                    if(data.data.need_redirect) {
                        window.location.href = data.data.redirect;
                    }
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        cancelOtp(item) {
            if (!item) return;
            item._otpMode = false;
            item._otpCode = '';
        },

        async sendOtp(item) {
            if (!item || !item.id) {
                EventBus.$emit('show_toast', { err: this.__t('SAVE_FIRST'), type: "warning", title: 'OTP' });
                return;
            }
            if (!item._otpCode) {
                EventBus.$emit('show_toast', { err: this.__t('ENTER_OTP_CODE'), type: "warning", title: 'OTP' });
                return;
            }

            this.rowSaving = item;
            agr_api.patch('/aggregators/glovo/' + item.id + "/otp_auth/" + item._otpCode).then(({data}) => {
                if (data.status === 'operation_success') {
                    item._otpMode = false;
                    item._otpCode = '';
                    EventBus.$emit('show_toast', { err: this.__t('OTP_CONFIRMED') || 'OTP підтверджено', type: "success", title: 'OK' });


                    this.loadAttachedManager();
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });

            this.rowSaving = null;
        },

        show_modal(event) {
            if (event && event.hasOwnProperty("provider_type")) {
                this.manager_type = event.provider_type;
            }
            if (event && event.hasOwnProperty("provider_id")) {
                this.manager_id = event.provider_id;
            }

            this.loadAttachedManager();
            this.is_show_modal = true;
        },

        async loadAttachedManager() {
            this.attached_items = [];
            this.is_load = true;

            await api.get('/internal/ext_auth/' + this.manager_type)
                .then(({ data }) => {
                    if (data.status === "operation_success") {
                        this.attached_items = data.data || [];
                        this.manager_settings.fields = data.message.fields || [];
                    }
                })
                .catch(({ response }) => {
                    EventBus.$emit('show_toast', { err: response?.data?.message || 'Load error', type: "danger", title: response?.data?.status || 'Error' });
                })
                .finally(() => {
                    this.is_load = false;
                });
        },



        addItem() {
            this.attached_items.push({
                id: null,
                username: '',
                password: '',
                _new: true,
            });
        },

        async setDefault(item) {
            if (!item || !item.id) return;

            this.is_load = true;

            await api.post(`/internal/ext_auth/${this.manager_type}/${item.id}/set_default`)
                .then(({ data }) => {
                    if (data.status === 'operation_success') {

                        this.attached_items.forEach(i => i.is_default = (i.id === item.id));
                        EventBus.$emit('show_toast', {
                            err: this.__t('DEFAULT_CHANGED') || 'Встановлено за замовчуванням',
                            type: 'success',
                            title: 'OK'
                        });
                    } else {
                        throw new Error(data.message || 'Set default failed');
                    }
                })
                .catch((e) => {
                    EventBus.$emit('show_toast', {
                        err: e?.response?.data?.message || e.message || 'Set default error',
                        type: 'danger',
                        title: 'Error'
                    });
                })
                .finally(() => {
                    this.is_load = false;
                });
        },

        async saveItem(item) {
            if (!item) return;

            this.rowSaving = item;

            const payload = { username: item.username, password: item.password };
            const itm_id = item?.id ?? 0;
            const urlBase = `/internal/ext_auth/${this.manager_type}/${itm_id}`;

            await api.put(urlBase, payload)
                .then(({ data }) => {
                    const otpTriggered =
                        data?.data?.error?.data?.message === 'OTP_TRIGGERED' ||
                        data?.data?.error?.message === 'OTP_TRIGGERED' ||
                        data?.data?.otp === true;

                    if (otpTriggered) {
                        this.$set(item, '_otpMode', true);
                        this.$set(item, '_otpCode', '');
                        EventBus.$emit('show_toast', { err: this.__t('OTP_TRIGGERED_ENTER_CODE') || 'Введіть код з SMS', type: "info", title: 'OTP' });
                        return;
                    }

                    if (data.status === "operation_success") {
                        this.loadAttachedManager();
                    } else {
                        throw new Error(data?.message || 'Save failed');
                    }
                })
                .catch((e) => {
                    EventBus.$emit('show_toast', { err: e?.response?.data?.message || e.message || 'Save error', type: "danger", title: 'Error' });
                })
                .finally(() => {
                    this.rowSaving = null;
                });
        },

        async deleteItem(item) {
            if (!item.id) {
                this.attached_items = this.attached_items.filter(i => i !== item);
                return;
            }

            this.rowDeleting = item;

            await api.delete(`/internal/ext_auth/${this.manager_type}/${item.id}`)
                .then(({ data }) => {
                    if (data.status === 'operation_success') {
                        this.attached_items = this.attached_items.filter(i => i.id !== item.id);
                        EventBus.$emit('show_toast', { err: this.__t('DELETED') || 'Удалено', type: "success", title: 'OK' });
                    } else {
                        throw new Error(data.message || 'Delete failed');
                    }
                })
                .catch((e) => {
                    EventBus.$emit('show_toast', { err: e?.response?.data?.message || e.message || 'Delete error', type: "danger", title: 'Error' });
                })
                .finally(() => {
                    this.rowDeleting = null;
                });
        },
    },

    computed: {
        dialog_class_draw() {
            return "modal-dialog-left";
        },

        draw_fields() {
            let res = this.fields;

            if(this.manager_settings.fields.length > 0) {
                this.manager_settings.fields.map(item => {
                    res.push({
                        key: item.type,
                        label: item.label,
                        class: 'text-center',
                    });
                })

            }

            res.push({ key: 'is_default', label: '', class: 'text-center', thStyle: { width: '40px' }});
            res.push({ key: 'actions',   label: '',  class: 'text-left', thStyle: { width: '220px' }});

            return res;
        },
    }
}
</script>

<style scoped>
/* при необходимости стилизуй кнопки/ячейки */
</style>
